<template>
  <div class="login-page">
    <van-button type="primary" style="width:60%" size="large" class="centered-button" @click="handleWxworkLogin">
      企业微信登录
    </van-button>
  </div>
  <!-- <div class="center-container">
    <img src="https://bmc-media.cdn.bcebos.com/serverupload/bmc-logo.png" class="logo-above" />
    <van-button type="primary" size="large" class="centered-button" @click="handleWxworkLogin">
      企业微信登录
    </van-button>
  </div> -->
</template>

<script>
import Vue from 'vue';

import config from '@/config'
import {
  Button,Image as VanImage } from 'vant';
  Vue.use(Button);
  Vue.use(VanImage);
export default {
  methods: {
    handleWxworkLogin() {
      // 生成随机state防止CSRF
      const state = Math.random().toString(36).substring(7)
      localStorage.setItem('wxwork_state', state)

      // 企业微信授权参数
      const redirectUri = encodeURIComponent(`${window.location.origin}/auth`)
      const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.qywx.appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${state}&agentid=${config.qywx.agentId}#wechat_redirect`  

      // 跳转到企业微信授权
      window.location.href = authUrl
    }
  },
 
}
</script>
<style lang="less" scoped>
.login-page {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
  height: 100vh;           /* 设置容器高度（根据需求调整） */
}
</style>